<template>
  <el-container
    v-loading="!isAppReady"
    v-if="isAppReady"
    :class="classObj"
    class="app-wrapper new-qs-container"
  >
    <template v-if="!fullScreenMode">
      <el-header class="header-wrapper">
        <Logo />
        <navbar
          :isHelp="isHelp()"
          :request="request"
          :http-methods="httpMethods"
          :showHelpCenterBySub="ignoreHelpCenter"
        >
          <template slot="navbar">
            <slot name="navbar"></slot>
          </template>
        </navbar>
      </el-header>
      <el-container>
        <el-aside class="container-aside" :class="{ 'no-second-menu': ignoreSecondMenu }">
          <left-menu
            class="sidebar-container"
            :ignoreSecondMenu="ignoreSecondMenu"
            :request="request"
            :cloudSetting="cloudSetting"
            :isShow="isShow"
            :activePathName="activePathName"
            :hover-submenu-key="hoverSubmenuKey"
            :submenu-key="submenuKey"
            :show-second-menu="showSecondMenu"
            @searchFocus="searchFocus"
          >
          </left-menu>
        </el-aside>
        <el-main style="padding: 0" class="outer-container-right-side">
          <div
            :class="[
              'main-container',
              ignoreSecondMenu ? 'no-menu' : '',
              isCollapse ? 'isCollapse' : '',
            ]"
          >
            <div class="main-container__content">
              <div id="watermark-container" class="watermark-container">
                <div id="main-container_box" class="main-container_box">
                  <slot name="contentTop"></slot>
                  <AppMain class="app-main-container">
                    <template slot="container">
                      <slot name="container"></slot>
                    </template>
                  </AppMain>
                  <slot name="contentBottom"></slot>
                </div>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </template>
    <div v-else style="overflow-y: scroll; height: 100vh">
      <AppBlankMain />
    </div>
  </el-container>
</template>
<script>
import { mapGetters } from 'vuex'
import Navbar from './components/Navbar.vue'
import AppMain from './components/AppMain.vue'
import AppBlankMain from './components/AppBlankMain.vue'
import ResizeMixin from './mixin/ResizeHandler'
import LeftMenu from './components/LeftMenu/index'
import Logo from './components/Logo.vue'

export default {
  name: 'OverLayout',
  mixins: [ResizeMixin],
  data() {
    this.tracePms = { kvKey: 'cp4.0_screenGuide' }
    return {
      fullScreenMode: false, // 监听全屏参数
      isHelpCenter: true,
      isVisible: true,
      platForm: location.pathname.split('/')[1],
      isShow: false, // 控制是否显示用户反馈入口
      cloudSetting: {}, // 用户反馈云控配置数据
    }
  },
  props: [
    // eslint-disable-next-line vue/no-unused-properties
    'authUtils',
    'request',
    'ignoreBrandList',
    'ignoreHelpCenter', // 该参数在父组件在子应用里 用来控制是否展示帮助中心
    'ignoreSecondMenu',
    'activePathName',
    'hoverSubmenuKey',
    'submenuKey',
    'showSecondMenu',
  ],
  watch: {
    request(val) {
      if (val) {
        window.myRequest = val
      }
    },
    $route: {
      handler() {
        this.platForm = location.pathname.split('/')[1]
      },
    },
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'isGetPermission',
      'brandList',
      'sidebar',
      'device',
      // eslint-disable-next-line vue/no-unused-properties
      'pathnames',
    ]),
    // 应用必备相关信息是否初始化准备好
    isAppReady() {
      const { userType = '' } = this.userInfo
      const readyPermission =
        this.userInfo.id && this.isGetPermission === false
      if (userType === 1) {
        return (
          readyPermission &&
          (this.ignoreBrandList ||
            (!this.ignoreBrandList && this.brandList.length > 0))
        )
      } else {
        return readyPermission
      }
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile',
      }
    },
  },
  components: {
    Navbar,
    AppMain,
    AppBlankMain,
    LeftMenu,
    Logo,
  },
  created() {
    const showHelpCenter = localStorage.SHOWHELPCENTER
    if (showHelpCenter && Number(showHelpCenter) !== 1) {
      this.isHelpCenter = false
      this.isVisible = false
    }
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.fullscreenchangeFn)
  },
  beforeDestroy() {
    window.removeEventListener('fullscreenchange', this.fullscreenchangeFn)
  },
  methods: {
    fullscreenchangeFn() {
      if (document.fullscreenElement) {
        this.fullScreenMode = true
      } else {
        this.fullScreenMode = false
      }
    },
    isHelp() {
      if (this.$route.path === '/welcome') {
        return false
      }
      return true
    },
    searchFocus() {
      const helpCenter = this.$refs.SearchHelpCenter
      helpCenter && helpCenter.handleSearch()
    },
    httpMethods(params = {}) {
      let tmpParams = {
        url: params.url || null,
        method: params.method || 'post',
        data: params.data || {},
      }
      tmpParams = Object.assign(tmpParams, params)
      return this.request(tmpParams)
    },
  },
}
</script>
<style>
#app {
  height: 100%;
  overflow-x: hidden;
}
</style>
<style lang="scss" scoped>
@import "./styles/mixin.scss";

$--color-aside-bg-start: #1B59DC;

.new-qs-container .sidebar-container .el-menu,
.new-qs-container.hideSidebar .el-aside.container-aside {
  width: 80px !important;
}
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  // 主体区域
  .header-wrapper {
    display: flex;
    height: 48px !important;
    padding: 0;
    overflow: auto !important;
    z-index: 9;
    background-color: $--color-aside-bg-start;
  }
  .container-aside {
    width: 248px;
    max-width: 248px;
    transition: all 0.1s;
    overflow: hidden;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1) !important;
    &.no-second-menu {
      width: 80px !important;
    }
  }
  .main-container {
    min-height: 100%;
    transition: margin-left 0.1s;
    margin-left: 0px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    .main-container_box {
      display: flex;
      flex-direction: column;
      height: calc(100vh - 44px);
      position: relative;
      .app-main-container {
        box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        margin: 12px 16px 16px 16px;
      }
    }
    .main-container__content {
      min-height: calc(100vh - 200px);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #fff;
    }
  }
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
  .sidebar-container {
    position: absolute;
    top: 48px;
    bottom: 0;
    left: 0;
  }
  .main-container {
    overflow-x: auto;
    min-width: 952px;
    ::v-deep .bottom-action-inner {
      left: 264px !important;
      margin-left: 0;
    }
  }
  .main-container.isCollapse {
    ::v-deep .bottom-action-inner {
      left: 96px !important;
      margin-left: 0;
    }
  }
}
</style>
